import React from 'react';

const SlideUpIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none">
            <path
                d="M5.00006 5.53327C4.86672 5.53327 4.73339 5.53327 4.66672 5.39993L0.666724 1.39994C0.466724 1.19994 0.466724 0.866602 0.666724 0.666602C0.866724 0.466602 1.20006 0.466602 1.40006 0.666602L5.06672 4.33327L8.73339 0.666602C8.93339 0.466602 9.26672 0.466602 9.46672 0.666602C9.66672 0.866602 9.66672 1.19994 9.46672 1.39994L5.46672 5.39993C5.40006 5.4666 5.26672 5.53327 5.13339 5.53327H5.00006Z"
                fill="currentColor"/>
        </svg>
    )
}

export default SlideUpIcon;